
import { useEffect } from "react";



const useDestroy = (
  callback: (...rest: unknown[]) => void
) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => () => callback(), [])
}

export default useDestroy;